<template>
    <div class="naw">
        <div class="form-wrapper">

            <h2>Vul je gegevens in en maak gratis kans op <strong>{{ prize }}!</strong></h2>

            <p v-if="numCorrect !== 6">Niet tevreden met je score? <br/><router-link to="game" tabindex="-1" >Probeer het dan opnieuw</router-link>.</p>

            <v-form ref="form" @formComplete="toResult"></v-form>

            <!-- <router-link class="play-again-link" v-if="numCorrect !== 6" to="game">Opnieuw spelen</router-link> -->
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-wrapper{
        margin:0 auto;
    }
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Form from '@/app/components/Form';

    export default {
        components: {
            'v-form': Form
        },

        computed:
        {
            numCorrect()
            {
                return this.$store.getters['getCorrectBalls'].length;
            },

            prize()
            {
                let prizeList = [
                    '€500',
                    '€1.000',
                    '€2.000',
                    '€3.000',
                    '€4.000',
                    '€4.500'
                ];

                return prizeList[ this.numCorrect - 1 ];
            }
        },

        methods: {
            backToGame()
            {
                this.$router.push( '/game' );
            },

            toResult()
            {
                this.$router.replace( '/bedankt' );
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                // tl.fromTo( '.lotto-logo.extended', 0.5, { x: '-71.03%' }, { x: '0%' }, 0 );
                tl.staggerFrom( '.form-wrapper > *', 0.3, { y: 20, opacity: 0 }, 0.2, 0 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( this.$el, 0.3, { opacity: 0 });

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Naw.vue